import { object } from 'zod';

import {
  CountProductsBySchema,
  ProductCountingRoundStrategySchema,
  ProductGroupsSchema,
} from '@occc/validation';

export const BaseEligibleEarnSchema = object({
  countProductsBy: CountProductsBySchema,
  roundCountedProducts: ProductCountingRoundStrategySchema,
  eligibleProductGroups: ProductGroupsSchema,
});
